import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export default function CountUp({
    end = 0,
    duration = 1800,
    suffix = "",
    prefix = "",
    className = "",
    decimals = 0,
}) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, amount: 0.4 });
    const [value, setValue] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const start = performance.now();
        let frame;
        const tick = (now) => {
            const elapsed = now - start;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setValue(end * eased);
            if (progress < 1) frame = requestAnimationFrame(tick);
            else setValue(end);
        };
        frame = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(frame);
    }, [inView, end, duration]);

    const formatted = decimals
        ? value.toFixed(decimals)
        : Math.round(value).toLocaleString("en-IN");

    return (
        <span ref={ref} className={`tabular ${className}`}>
            {prefix}
            {formatted}
            {suffix}
        </span>
    );
}
